import React from 'react';
import { COLORS } from '@constants';
import { PLATFORM_ID } from '@enums';
import { useStore } from '@hooks';
import { Icon, Typography } from '@ui';
import { formatString } from '@utils';
import { observer } from 'mobx-react';
import { StyledMenuItem } from './styled';

const MenuAccountItem = observer(({ item }) => {
    const store = useStore();
    const currentAccountItem = store.accountsStore?.currentAccount?.id === item.id;

    const renderPlatformIcon = () => {
        switch (item.platformId) {
            case PLATFORM_ID.SHOPIFY:
                return <Icon.ShopifyLogo />;
            case PLATFORM_ID.BIGCOMMERCE:
                return <Icon.BigCommerceIcon />;
            case PLATFORM_ID.KLICKLY:
                return <Icon.KlicklyLogo />;
            default:
                return <Icon.KlicklyLogo />; // Fallback icon
        }
    };

    return (
        <StyledMenuItem
            data-e2e={`header_user-dropdown-menu_${formatString(item.companyName)}_account`}
            gap={16}
            onClick={item.onClick}
            align='center'
            $currentAccountItem={currentAccountItem}
        >
            <Icon color={COLORS.$gray60Black} size='16px' component={renderPlatformIcon} />

            <Typography.Text
                data-e2e={`header_user-dropdown-menu_${formatString(item.companyName)}_account-name`}
                color={COLORS.$gray60Black}
                className='asd'
                type='descriptor1'
            >
                {item.companyName}
            </Typography.Text>
        </StyledMenuItem>
    );
});

export default MenuAccountItem;
